<template>
  <el-select
    v-model="submit_data[data.key]"
    size="default"
    v-bind="select_attrs"
    :value-key="data.valuekey"
    :multiple="data.multiple ? true : false"
    :placeholder="data.desc"
    clearable
    filterable
    :teleported="true"
    placement="top"
    @change="onChange"
    @visible-change="onVisibleChange"
    @remove-tag="onRemoveTag"
    @clear="onClear"
  >
    <el-option
      v-for="(item,index) in data.list"
      v-bind="option_attrs"
      :key="index"
      :value="item[value_attr]"
      :label="item[label_attr]"
    />
  </el-select>
</template>

<script>
import Common from './js/Common';

const Js = Common('sls-select');

Js.mixins = [{
  data() {
    return {
    };
  },
  computed: {
    select_attrs() {
      return this.Data.select_attrs || {};
    },
    option_attrs() {
      return this.Data.option_attrs || {};
    },
  },
  methods: {
    onChange(v) {
      // console.log(v);
      if (v) {
        if (Array.isArray(v)) {
          this.submit_info[this.data.key] = [];
          v.forEach((item) => {
            this.submit_info[this.data.key].push(this.temp_field_obj[this.data.key][item]);
          });
        } else {
          this.submit_info[this.data.key] = '';
          this.submit_info[this.data.key] = this.temp_field_obj[this.data.key][v];
        }
      }

      if (this.events.change) {
        this.events.change({ value: v, info: this.submit_info[this.data.key] });
      }
    },

    onVisibleChange() {
      if (this.events['visible-change']) this.events['visible-change']();
    },

    onRemoveTag() {
      if (this.events['remove-tag']) this.events['remove-tag']();
    },

    onClear() {
      if (this.events.clear) this.events.clear();
    },
  },
  created() {
  },
},
];
export default Js;
</script>
